import { Action } from '@ngrx/store';

export enum LayoutActionTypes {
  OpenSidenav = '[Layout] Open Sidenav',
  CloseSidenav = '[Layout] Close Sidenav',
  ResetState = '[State] Reset State',
}

export class OpenSidenav implements Action {
  readonly type = LayoutActionTypes.OpenSidenav;
}

export class CloseSidenav implements Action {
  readonly type = LayoutActionTypes.CloseSidenav;
}
export class ResetState implements Action {
  readonly type = LayoutActionTypes.ResetState;
}

export type LayoutActionsUnion = OpenSidenav | CloseSidenav | ResetState;
